<template>
  <div v-if="node.type === 'group'" class="group-block">
    <div class="section-title">
      <span class="section-name">{{ node.name }}</span>
      <span class="section-stats" v-if="endpointChildren.length">
        <span class="stat free">{{ freeCount }} free</span>
        <span class="stat in-use" v-if="inUseCount">{{ inUseCount }} Booked</span>
      </span>
    </div>
    <div class="table-grid" v-if="endpointChildren.length">
      <div
          v-for="child in endpointChildren"
          :key="child.id"
          class="table-card"
          :class="child.service_general_status"
          @click="$emit('select', child)"
      >
        <i class="fas fa-utensils table-icon"></i>
        <span class="table-name">{{ child.name }}</span>
        <span class="status-badge">{{ statusLabel(child.service_general_status) }}</span>
      </div>
    </div>
    <RestaurantPosTableNode
        v-for="group in groupChildren"
        :key="group.id"
        :node="group"
        @select="$emit('select', $event)"
    />
  </div>
</template>

<script setup>
import {computed} from 'vue';

const props = defineProps({
  node: {
    type: Object,
    required: true
  }
});

defineEmits(['select']);

const childList = computed(() => props.node.child || []);

const endpointChildren = computed(() => childList.value.filter(child => child.type === 'endpoint'));

const groupChildren = computed(() => childList.value.filter(child => child.type === 'group'));

const freeCount = computed(() => endpointChildren.value.filter(child => child.service_general_status !== 'occupied').length);

const inUseCount = computed(() => endpointChildren.value.filter(child => child.service_general_status === 'occupied').length);

const statusLabel = (status) => {
  if (status === 'occupied') return 'Booked';
  return 'Available';
};
</script>

<style scoped>
.group-block {
  margin-bottom: 18px;
}

.group-block .group-block {
  margin-left: 16px;
  padding-left: 14px;
  border-left: 2px dashed #d8e2ee;
  margin-bottom: 14px;
}

.section-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #f4f7fb;
  border-left: 4px solid #7367f0;
  border-radius: 8px;
  padding: 8px 14px;
  margin-bottom: 14px;
}

.section-name {
  font-size: 15px;
  font-weight: 700;
  color: #2f3a4c;
}

.section-stats {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.stat {
  font-size: 11px;
  font-weight: 700;
  padding: 2px 10px;
  border-radius: 20px;
}

.stat.free {
  color: #1d8a55;
  background: #e8f8ef;
  border: 1px solid #b6e6cb;
}

.stat.in-use {
  color: #a9791a;
  background: #fff6da;
  border: 1px solid #f4dd92;
}

.table-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 12px;
  margin-bottom: 14px;
}

.table-card {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  height: 82px;
  border-radius: 12px;
  cursor: pointer;
  font-weight: 600;
  border: 1.5px solid transparent;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
  transition: all 0.2s ease;
}

.table-card:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.12);
}

.table-card.open {
  background: #e8f8ef;
  border-color: #b6e6cb;
  color: #1d8a55;
}

.table-card.occupied {
  background: #fff6da;
  border-color: #f4dd92;
  color: #a9791a;
}

.table-icon {
  font-size: 17px;
  opacity: 0.95;
}

.table-name {
  font-size: 13px;
}

.status-badge {
  font-size: 9px;
  font-weight: 700;
  letter-spacing: 0.2px;
  padding: 1px 8px;
  border-radius: 20px;
}

.table-card.open .status-badge {
  background: #1d8a55;
  color: #fff;
}

.table-card.occupied .status-badge {
  background: #d9a126;
  color: #fff;
}
</style>
